import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import VueSwal from 'vue-swal'
import Vue2Filters from 'vue2-filters'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VueQr from 'vue-qr'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faUserSecret)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)


const moment = require('moment');
require('moment/locale/es');

Vue.use(Datetime);
Vue.use(VueSwal);
Vue.use(Vue2Filters);
Vue.use(BootstrapVue);
Vue.use(VueQr);
Vue.use(require('vue-moment'), {
    moment
});
const options = {
  toast: {
    position: SnotifyPosition.centerTop
  }
};

Vue.use(Snotify, options);
Vue.config.productionTip = false;
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});